require('./mod.select');

function showTicketForm() {
	$('#show_ticket_form').on('click', function() {
		$('#ticket_form').fadeToggle();
	});

	$('#hide_ticket_form').on('click', function() {
		$('#ticket_form').fadeOut();
	});
}

function JustifiedGallery() {
	$('.justified-gallery').each(function() {
		var $align = 'nojustify';
		if ($(this).parents('.ticket__item').hasClass('ticket__item--received')) {
			$align = 'left';
		} else if (!$(this).parents('.ticket__item').hasClass('ticket__item--received')) {
			$align = 'right';
		}

		$(this).justifiedGallery({
			rowHeight: 110,
			maxRowHeight: 110,
			lastRow: $align,
			selector: '.justified-item',
			margins: 10,
			refreshTime: 200
		});
	});
}

$(function() {
	showTicketForm();
	JustifiedGallery();
});